import { Reveal, Overline } from "./Reveal";
import { BENEFITS, DIFFERENTIALS } from "../../lib/content";

export const Benefits = () => (
  <section id="beneficios" className="relative py-24 md:py-36 scroll-mt-20" data-testid="benefits-section">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal className="text-center max-w-3xl mx-auto">
        <Overline>{BENEFITS.overline}</Overline>
        <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight">
          {BENEFITS.title}
        </h2>
        <p className="mt-5 text-white/55 text-lg">{BENEFITS.subtitle}</p>
      </Reveal>

      <div className="mt-14 grid md:grid-cols-3 gap-5">
        {BENEFITS.items.map((b, i) => {
          const Icon = b.icon;
          return (
            <Reveal key={b.title} delay={i * 0.1}>
              <div className="group relative h-full overflow-hidden rounded-3xl border border-white/10 bg-bf-surface p-8 hover:-translate-y-1 transition-transform duration-300">
                <div className="absolute inset-x-0 -top-24 h-40 bg-bf-yellow/10 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="relative flex h-12 w-12 items-center justify-center rounded-xl bg-bf-yellow text-black">
                  <Icon size={22} strokeWidth={2} />
                </div>
                <h3 className="relative mt-6 font-display text-2xl font-bold tracking-tight">{b.title}</h3>
                <p className="relative mt-3 text-white/60 leading-relaxed">{b.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>

      {/* Differentials strip */}
      <div className="mt-24 rounded-3xl border border-white/10 bg-gradient-to-b from-white/[0.04] to-transparent p-8 md:p-14">
        <div className="grid md:grid-cols-12 gap-10 items-start">
          <Reveal className="md:col-span-5">
            <Overline>{DIFFERENTIALS.overline}</Overline>
            <h3 className="mt-5 font-display text-3xl md:text-4xl font-extrabold tracking-tight">
              {DIFFERENTIALS.title}
            </h3>
            <p className="mt-4 text-white/60 text-lg leading-relaxed">{DIFFERENTIALS.body}</p>
          </Reveal>
          <div className="md:col-span-7 grid sm:grid-cols-3 gap-6">
            {DIFFERENTIALS.items.map((d, i) => {
              const Icon = d.icon;
              return (
                <Reveal key={d.title} delay={i * 0.08}>
                  <Icon className="text-bf-teal" size={26} strokeWidth={1.75} />
                  <h4 className="mt-4 font-display text-lg font-bold">{d.title}</h4>
                  <p className="mt-2 text-sm text-white/55 leading-relaxed">{d.desc}</p>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  </section>
);
